import React from 'react';

import { MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import useUserHook from 'hooks/useUserHook';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import classes from 'components/widgets/RenderLibraryTable/components/ActionMenu/ActionMenu.module.scss';

export interface LinkProps {
    id: string;
    link: string;
    search: string;
    title: string;
}

export const getLinks = (links: LinkProps[]) => {
    return links.map((linkObject, index) => (
        <MenuItem key={index}>
            <Link
                className={classes.actionMenuLink}
                id={linkObject.id}
                to={{ pathname: linkObject.link, state: { fromActionMenu: true }, search: linkObject.search }}
            >
                {linkObject.title}
            </Link>
        </MenuItem>
    ));
};

export const prepareLinks = (id: number) => {
    const { ability } = useUserHook();

    const criticalLink = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_RISK_APPS_PATH,
        riskConfig.criticalityAnalysis.link,
        id,
    );
    const progressOverviewLink = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_EXECUTION_PATH,
        executionConfig.progressOverview.link,
        id,
    );
    const ganttChartLink = AppRoutes.buildPath(AppRoutes.DASHBOARD_PLANNING_PATH, executionConfig.ganttChart.link, id);
    const crossVersionAnalysisLink = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_RISK_APPS_PATH,
        executionConfig.crossVersionsAnalysis.link,
        id,
    );
    const dataStoriesLink = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_EXECUTION_PATH,
        executionConfig.dataStories.link,
        id,
    );
    const statusSummaryLink = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_EXECUTION_PATH,
        executionConfig.statusSummary.link,
        id,
    );
    const battleCardsLink = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_EXECUTION_PATH,
        executionConfig.battlecards.link,
        id,
    );

    const clusterrcfanalysisLink = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_PLANNING_PATH,
        riskConfig.durationForecast.link,
        id,
    );
    const clusterrcfanalysisCustomLink = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_PLANNING_PATH,
        riskConfig.durationForecast.link,
        id,
    );
    const logicCheckerLink = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_PLANNING_PATH,
        riskConfig.logicQualityCheck.link,
        id,
    );

    return {
        singleProgram: [
            {
                link: statusSummaryLink,
                title: executionConfig.statusSummary.title,
                id: 'StatusSummary',
            },
            {
                link: battleCardsLink,
                title: executionConfig.battlecards.title,
                id: 'BattleCards',
                search: 'cardActivity=1,2',
            },
            {
                link: dataStoriesLink,
                title: executionConfig.dataStories.title,
                id: 'DataStories',
            },
            {
                link: progressOverviewLink,
                title: executionConfig.progressOverview.title,
                id: 'ProgressOverview',
            },
            {
                link: criticalLink,
                title: riskConfig.criticalityAnalysis.title,
                id: 'CriticalityAnalysis',
            },
            {
                link: crossVersionAnalysisLink,
                title: executionConfig.crossVersionsAnalysis.title,
                id: 'CrossVersionAnalysis',
            },
            {
                link: ganttChartLink,
                title: executionConfig.ganttChart.title,
                id: 'GanttChart',
            },

            {
                link: clusterrcfanalysisLink,
                title: riskConfig.durationForecast.title,
                id: 'ForecastDuration',
            },
            {
                link: clusterrcfanalysisCustomLink,
                title: `${riskConfig.durationForecast.title} Custom Search`,
                id: 'ForecastDurationCustomSearch',
                search: '?option=custom',
            },
            {
                link: logicCheckerLink,
                title: riskConfig.logicQualityCheck.title,
                id: 'LogicChecker',
            },
        ].filter((item) => (ability.can('all', 'Admin') ? item : !item.isAdmin)),
        multipleWithContractProgram: [
            {
                link: statusSummaryLink,
                title: executionConfig.statusSummary.title,
                id: 'StatusSummary',
            },
            {
                link: progressOverviewLink,
                title: executionConfig.progressOverview.title,
                id: 'ProgressOverview',
            },
            {
                link: criticalLink,
                title: riskConfig.criticalityAnalysis.title,
                id: 'CriticalityAnalysis',
            },
            {
                link: crossVersionAnalysisLink,
                title: executionConfig.crossVersionsAnalysis.title,
                id: 'CrossVersionAnalysis',
            },
            {
                link: clusterrcfanalysisLink,
                title: riskConfig.durationForecast.title,
                id: 'ForecastDuration',
            },
            {
                link: clusterrcfanalysisCustomLink,
                title: `${riskConfig.durationForecast.title} Custom Search`,
                id: 'ForecastDurationCustomSearch',
                search: '?option=custom',
            },
        ],

        multipleWithoutContractProgram: [
            {
                link: clusterrcfanalysisLink,
                title: riskConfig.durationForecast.title,
                id: 'ForecastDuration',
            },
            {
                link: clusterrcfanalysisCustomLink,
                title: `${riskConfig.durationForecast.title} Custom Search`,
                id: 'ForecastDurationCustomSearch',
                search: '?option=custom',
            },
        ],
    };
};
